import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// Types
import MediaFormats from 'types/MediaFormats';
// Components
import { Input } from 'components/Controls';
import ImageUpload from 'components/ImageUpload';
import MultiLanguageTextField from 'components/MultiLanguageTextField';
import Accordion from 'components/Accordion';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  index: number;
}

const PostQuizPage:FC<Props> = ({
  // Props
  index
}) => {
  const { t } = useTranslation();

  const { control, getValues } = useFormContext();

  const getBuckets = getValues('buckets');

  const bucketName = (index:number) => {
    if ( !getBuckets || !getBuckets.length ) return '';
    // ToDO
    if ( !getBuckets[index] ) return '';

    return getBuckets[index].title;
  }

  return (
    <div react-scroll={`post-quiz-page-${index}`}>
      <Accordion label={bucketName(index)} icon="delete">
        <div className="w-full">
          <div className="flex flex-wrap -mx-2 px-6 pb-3">
            <div className="w-full laptop:w-1/2 px-2">
              <Controller
                control={control} name={`postQuizPages[${index}].callToAction.image`}
                render={({ field }) => (
                  <ImageUpload
                    {...field}
                    format={MediaFormats.CTA}
                    label={t('labels.image')}
                  />
                )}
              />
            </div>
            <div className="w-full laptop:w-1/2 px-2">
              <Controller
                control={control} name={`postQuizPages[${index}].callToAction.url`}
                render={({ field }) => (
                  <Input
                    {...field}
                    id={`postQuizPages[${index}].callToAction.url`}
                    label={t('labels.url')}
                  />
                )}
              />
              <MultiLanguageTextField
                name={`postQuizPages[${index}].callToAction.text`}
                multiline
                rows={4}
                label={t('labels.text')}
                className="mb-2"
              />
              <MultiLanguageTextField
                name={`postQuizPages[${index}].callToAction.buttonTitle`}
                label={t('labels.buttonTitle')}
              />
            </div>
          </div>
        </div>
      </Accordion>
    </div>
  )
}

export default PostQuizPage;
